import type { CartItem } from '@sola/schema/dotcom/cart/cart-item.ts';
import { CartItemTypeEnum } from '@sola/schema/dotcom/cart/cart-item.ts';
import { CommitmentFrequencyEnum } from '@sola/schema/dotcom/cart/commitments.ts';
import type { CartItemFundPayload } from '@sola/schema/dotcom/cart/fund.ts';
import type { AddonOverride } from '@sola/schema/dotcom/shared/content/campaigns.ts';

import type { CartAddOn } from './types/addons.ts';

export const defaultAddon: CartAddOn = {
  commitmentFrequency: CommitmentFrequencyEnum.Monthly,
  cmsId: 'tcm:5-40613',
  unitPrice: 7,
  title: 'Disaster Relief',
};

export const currentAddon = (addonOverride?: AddonOverride) => {
  return addonOverride
    ? {
        ...addonOverride,
        commitmentFrequency: CommitmentFrequencyEnum.Monthly,
      }
    : defaultAddon;
};

/**
 * Get a cart item's addon amounts.
 */
export const calcItemAmountWithAddOn = (
  item: CartItem,
  currentAddOn?: CartAddOn,
  relatedItem?: CartItem,
): {
  combinedAmount: number;
  fundAmount: number;
} => {
  if (
    item.itemType !== CartItemTypeEnum.Sponsorship ||
    (!currentAddOn && !relatedItem)
  ) {
    return { combinedAmount: item.amount, fundAmount: item.amount };
  }

  const quantityOfChildren = 1;
  // If we wanted to do an add-on per child
  // isItemSponsorshipCriteria(item) || isItemSponsorshipLongestWaiting(item)
  //   ? item.sponsorship.quantity
  //   : 1;
  const fundAmount =
    !relatedItem && currentAddOn
      ? quantityOfChildren * currentAddOn.unitPrice
      : (relatedItem?.amount ?? 0);
  const combinedAmount = fundAmount + item.amount;

  return { combinedAmount, fundAmount };
};

export const formatAddOnItemToAdd = (
  parent: CartItem,
  currentAddOn: CartAddOn,
): CartItemFundPayload => {
  return {
    itemType: CartItemTypeEnum.Fund,
    unitPrice: calcItemAmountWithAddOn(parent, currentAddOn).fundAmount,
    commitmentFrequency: CommitmentFrequencyEnum.Monthly,
    fund: {
      cmsId: currentAddOn.cmsId,
    },
  };
};
